const defaults = {
  authDomain: "",
  authLogonUri: "/logon",
  authLogoffUri: "/logoff",
  authRenewUri: "/renew",
  tokenChanged: x => x,
}

export default defaults
